{
  "features": {
    "filePreview": {
      "measurements": {
        "label": "Measured shapes on this page",
        "show": "Show measurements",
        "unlabelled": "Unlabelled",
        "count": "{count, plural, one {# shape} other {# shapes}}",
        "measured": "Measured: {total}"
      }
    },
    "scopeBreakdown": {
      "title": "Scope breakdown",
      "frame": {
        "none": "Volve reads every tender file into a sheet in your standard",
        "running": "Writing the scope breakdown",
        "failed": "The last run failed",
        "partial": "Partly written. Update to finish",
        "ready": "Your standard's scope breakdown, as a sheet",
        "unavailable": "Being updated"
      },
      "page": {
        "no-documents": {
          "title": "No documents to read",
          "description": "Upload the tender's documents, or retry the ones that could not be analyzed.",
          "action": "Go to files"
        },
        "preparing": {
          "title": "Preparing the documents",
          "description": "You can run the scope breakdown once the tender's documents are analyzed."
        },
        "empty": {
          "title": "No scope breakdown yet",
          "description": "Volve reads every tender file and writes the scope breakdown as a sheet, in the standard you choose."
        },
        "running": {
          "title": "Starting the run",
          "description": "The sheet appears here once the run creates it and fills as Volve reads the files."
        },
        "unavailable": {
          "title": "Scope breakdown is being updated",
          "description": "The new scope breakdown is not available yet. Try again after the update."
        },
        "failed": {
          "title": "Could not load document status",
          "description": "Try again to check whether the documents are ready.",
          "action": "Try again"
        }
      },
      "runAlert": {
        "failed": {
          "title": "The last run failed",
          "run": "The breakdown stopped before it finished. Retry with your saved settings.",
          "update": "Your saved work is kept. Retry to continue the breakdown.",
          "reasons": {
            "time_limit": "The run reached its time limit before writing a row.",
            "allowance": "The run used up its model calls before writing a row.",
            "answer_refused": "The run's answer did not account for every tender file, and it stopped before writing a row.",
            "agent_failed": "The agent stopped before writing a row.",
            "no_standard": "The run names no structure. Choose one and run again.",
            "expired": "The run stopped responding and was ended.",
            "crashed": "The run stopped on an internal error.",
            "invalid_result": "The run stopped because a result could not be processed.",
            "invalid_source": "Required documents must finish indexing before the run can start."
          }
        },
        "partial": {
          "title": "The last run did not finish everything",
          "description": "{count, plural, =0 {The breakdown stopped before finishing. Update to continue from your saved work.} one {# file could not be read. Update to try again. Your saved work is kept.} other {# files could not be read. Update to try again. Your saved work is kept.}}",
          "notRead": "Not read"
        },
        "running": {
          "run": "Volve is reading the contract. Requirements show as they are found; packages come when it is done.",
          "update": "Volve is updating the breakdown. You can keep working; changes appear when it is done."
        }
      },
      "run": {
        "run": "Start breakdown",
        "update": "Update",
        "runDescription": "Volve reads the tender requirements and proposes work packages. You choose how to describe each package afterwards.",
        "updateDescription": "Volve reads new or changed documents. Your package choices and edits are preserved.",
        "startNew": "Start a new breakdown",
        "startNewDescription": "Create a new breakdown from the tender documents. Existing sent packages remain unchanged.",
        "structure": "What should define the structure?",
        "structures": {
          "library": {
            "title": "A standard",
            "description": "Volve reads the standard and uses its chapters as disciplines and packages."
          },
          "volve": {
            "title": "Volve’s template",
            "description": "Volve’s general work-package structure."
          },
          "template": {
            "title": "Your template",
            "description": "Your company’s structure, uploaded or from the knowledge base."
          },
          "tender_bill": {
            "title": "Tender’s own quantity list",
            "description": "The client’s posts, codes and order."
          }
        },
        "standards": "Standards",
        "uploadStandard": "Upload standard or template",
        "standardPreparing": "Preparing your standard. It will be selected automatically when ready.",
        "standardFailed": "This standard could not finish preparing. Retry or continue without it.",
        "retryStandard": "Retry preparation",
        "skipStandard": "Continue without this standard",
        "standardsDescription": "Choose a technical standard, specification system, handbook or template. Uploads are saved in your library for reuse.",
        "noStandards": "No standards are ready yet. Upload a standard or template to get started.",
        "instructions": "Instructions",
        "instructionsPlaceholder": "For example, keep the client’s numbering and include the referenced appendices.",
        "instructionsUpdatePlaceholder": "Describe what the new or changed documents add.",
        "instructionsDescription": "Optional. Volve follows them beside the structure.",
        "files": "Tender files",
        "noFiles": "The tender has no files yet. Upload the template.",
        "upload": "Upload",
        "pickStructure": "Choose a structure",
        "pickStandard": "Pick at least one knowledge base that holds the standard",
        "pickFiles": "Pick at least one tender file for the template",
        "refused": {
          "preparing": "The tender's documents are still being prepared. Try again when they are ready.",
          "noDocuments": "The tender has no documents yet. Upload them first.",
          "noSheet": "There is no sheet to update. Start a new sheet instead."
        },
        "genericError": "An error occurred, please try again later",
        "retry": "Retry breakdown"
      },
      "outline": {
        "tree": "Codes",
        "search": "Search code or text",
        "posts": "Posts",
        "postCount": "{count, plural, one {# post} other {# posts}}",
        "allPackages": "All packages",
        "markers": {
          "inPackage": "In this package",
          "input": "Needs input",
          "assumed": "Has assumptions",
          "interface": "Interface or overlap",
          "empty": "Empty code",
          "orienting": "Orienting text"
        },
        "states": {
          "stated": "Stated in the documents",
          "assumed": "Assumed value",
          "input": "Needs input",
          "unsourced": "No source"
        },
        "expand": "Expand",
        "collapse": "Collapse",
        "noMatches": "No codes or rows match",
        "empty": "This sheet has no scope rows yet",
        "openSource": "Open source",
        "assign": "Assign",
        "move": "Move",
        "moveToCode": "Move to code",
        "chapterEnd": "Chapter, at the end",
        "package": "Package",
        "discipline": "Discipline",
        "exclude": "Exclude",
        "include": "Include again",
        "excluded": "Excluded",
        "task": "Task",
        "quotePage": "p. {page}",
        "flagsAssumptions": "{count, plural, one {# assumption} other {# assumptions}}",
        "flagsInputs": "{count, plural, one {# needs input} other {# need input}}",
        "legendLines": "Rows",
        "noValue": "—",
        "sourceCount": "{count, plural, one {# source} other {# sources}}",
        "assumed": "Assumed",
        "introduction": "Introduction",
        "orienting": {
          "label": "Orienting text",
          "hint": "Tender conditions that affect the prices below; not priced themselves.",
          "more": "+{count}",
          "showAll": "Show all {count}",
          "showLess": "Show less",
          "add": "Add condition",
          "addPlaceholder": "The condition, in the tender's words",
          "addSave": "Add",
          "cancel": "Cancel",
          "addedByYou": "Added by you",
          "comment": "Comment",
          "restore": "Restore",
          "marker": "{count, plural, one {# orienting text} other {# orienting texts}}",
          "recheck": "Conditions changed · Re-check posts",
          "recheckIntro": "The orienting text under {heading} in tab {tab} changed. Re-check the posts below it and adjust their scope and quantities where the change affects them:",
          "changes": {
            "added": "Added",
            "excluded": "Excluded",
            "restored": "Restored"
          }
        },
        "applies": {
          "label": "Applies here",
          "hint": "Inherited from the headings above. Edit at the heading.",
          "fromGroup": "from {code} · this group",
          "fromTrade": "from {code} · all posts",
          "goToHeading": "Go to heading",
          "showMore": "Show {count} more",
          "showLess": "Show less"
        },
        "edit": {
          "confirm": "Confirm",
          "edit": "Edit",
          "save": "Save",
          "cancel": "Cancel",
          "number": "Not a number",
          "option": "Not one of the options",
          "remeasure": "Re-measure this post",
          "remeasureInstruction": "Re-measure the quantity of post {post} in tab {tab}: {field} is now {value}."
        },
        "suggestedChanges": "Suggested changes",
        "suggestedField": "Suggested {field}",
        "clearSuggestedValue": "Clear this value",
        "acceptSuggestion": "Accept suggestion",
        "dismissSuggestion": "Keep my value",
        "suggestionCount": "{count, plural, one {# suggested change} other {# suggested changes}}"
      },
      "openCurrentSheet": "Open current sheet",
      "beta": "Beta",
      "overview": {
        "intro": "Choose the execution and description method for each package. You can change them later.",
        "standardStructure": "Structured by {standard}",
        "empty": "No extracted requirements yet. Start a breakdown to build work packages.",
        "suggestions": "{count, plural, one {# suggestion} other {# suggestions}}",
        "uncertain": "{count, plural, one {# uncertain placement} other {# uncertain placements}}",
        "conflicts": "{count, plural, one {# conflict} other {# conflicts}}",
        "allRequirements": "All requirements",
        "newPackage": "New package",
        "back": "Back to packages",
        "package": "Package",
        "requirements": "Requirements",
        "execution": "Execution",
        "method": "Description method",
        "status": "Status",
        "selectAll": "Select all packages",
        "selectPackage": "Select {name}",
        "expand": "Show requirements in {name}",
        "choose": "Choose…",
        "selfPerform": "Self-perform",
        "subcontract": "Subcontract",
        "packageRequirements": "All requirements in this package",
        "selected": "{count} selected",
        "clear": "Clear selection",
        "name": "Package name",
        "create": "Create package",
        "noRequirements": "No requirements in this package.",
        "saveFailed": "Could not save package choices. Try again.",
        "sent": "Sent v{version}",
        "next": {
          "requirements": "Next: check requirements",
          "choose-description": "Next: choose method",
          "work-pack": "Next: make description",
          "documents": "Next: generate pack",
          "send": "View sent package",
          "offers": "View offers",
          "add-information": "Add information",
          "generate": "Generate work pack",
          "proofread": "Proofread",
          "client-posts": "Next: review posts",
          "changes": "Next: review changes"
        },
        "generateSelected": "Generate descriptions ({count})",
        "generateFailed": "{count, plural, one {# package could not be queued.} other {# packages could not be queued.}} Other accepted packages continue.",
        "generateQueued": "Descriptions queued",
        "backgroundGeneration": "Generation continues in the background.",
        "running": {
          "title": "Volve is reading the contract",
          "description": "Requirements appear here as soon as the first ones are found. Packages come when the run is done."
        }
      },
      "start": {
        "title": "Start a breakdown",
        "choose": "Choose what the breakdown starts from.",
        "files": "Client’s documents",
        "pages": "{count, plural, one {# page} other {# pages}}",
        "profile": "Description standard",
        "chooseProfile": "Choose a saved profile…",
        "methods": "Available methods: {names}",
        "executionPending": "Execution-contract reading is not available yet. No run will start for this choice.",
        "client_posts": {
          "title": "Break down project from an execution contract",
          "description": "The client has written a description with chapters and {lines}. Volve keeps their structure and suggests work packs per chapter."
        },
        "requirements": {
          "title": "Break down a design and build contract",
          "description": "Volve breaks the contract down into scope items and sorts them into work packages."
        },
        "lines": "priced lines"
      },
      "detail": {
        "search": "Search requirements",
        "selected": "{count} selected",
        "include": "Include",
        "exclude": "Exclude",
        "move": "Move to",
        "saveFailed": "Could not save",
        "status": "Status",
        "viewSource": "View source",
        "citationScope": "Citation scope",
        "contractScope": "In the contract",
        "scopeHint": "Preview the source before saving. The contract scope controls what is included in the work pack.",
        "saveScopes": "Save scope choices",
        "sourceRecord": "Source record",
        "page": "Page {page}",
        "empty": "No requirements",
        "levels": {
          "exact": "Exact text",
          "paragraph": "Paragraph",
          "section": "Section",
          "chapter": "Chapter",
          "document": "Whole document"
        }
      },
      "package": {
        "missing": "Not available",
        "version": "Version {version}",
        "steps": "Package steps",
        "continue": "Continue",
        "chooseTitle": "How should the package be described?",
        "chooseHint": "Choose one method. You can change it later.",
        "contractStandard": "Contract standard",
        "choose": "Choose",
        "ownTerms": "Upload company terms",
        "lineStandards": "Standards for {lines}",
        "lines": "priced lines",
        "line": "priced line",
        "upload": "Upload documents",
        "askSuggestion": "Ask Volve for a suggestion",
        "saveFailed": "Could not save",
        "notGenerated": "Generate a description from this package’s requirements.",
        "noPosts": "No {lines} were written. Add a {line}, or a standard that covers these requirements.",
        "introduction": "Introduction",
        "noIntroduction": "No introduction yet",
        "edit": "Edit",
        "save": "Save",
        "conditions": "Framework conditions and common parts",
        "missingDocument": "Referenced but missing: {name}",
        "sourceFile": "Choose source file",
        "mapQuantities": "Suggest quantity mapping",
        "apply": "Apply",
        "rigging": "Rigging and operations",
        "blankLine": "New blank {line}",
        "code": "Code",
        "title": "Title",
        "quantity": "Quantity",
        "unit": "Unit",
        "remove": "Remove",
        "uncovered": "Requirements without a line: {count}",
        "withVolve": "Add with Volve",
        "instruction": "Describe what the new lines should cover",
        "draft": "Suggest lines",
        "acceptDrafts": "{count, plural, one {Accept # suggestion} other {Accept # suggestions}}",
        "deliveryMatrix": "Delivery responsibility",
        "removedLines": "Removed lines",
        "undo": "Undo",
        "editLine": "Edit {line}",
        "summary": "Summary",
        "location": "Location",
        "clientOriginal": "Client’s original wording",
        "history": "Internal edit history",
        "method": {
          "performance": "Send the client’s requirements in their own words, with a summary and delivery matrix.",
          "itemised": "Generate {lines} according to the selected standard, with quantities and linked requirements."
        },
        "fit": {
          "performance": "Fits when the subcontractor is responsible for developing the solution.",
          "itemised": "Fits when the solution is defined and prices will be compared line by line."
        },
        "publicationFailed": "The description is saved, but its sheet could not be published. Retry without generating it again.",
        "previewCode": "Preview code from choices",
        "regenerateDescription": "Generate new version",
        "assumption": "Assumption",
        "chooseValue": "Choose a value",
        "doneLinking": "Done linking",
        "confirmMapping": "Confirm this match before applying the quantity.",
        "workflowUnavailable": "Sending and offer review are not connected in this preview. The current editable package is separate from a sent snapshot.",
        "reviewCurrent": "Review current package"
      },
      "delivery": {
        "saveFailed": "Could not save changes",
        "summary": "Package summary",
        "documents": "Work pack documents",
        "undo": "Undo",
        "notRelevant": "Not relevant",
        "upload": "Upload",
        "chooseFile": "Choose an existing file",
        "noSections": "This profile has no document sections yet. Update the standard profile to add them.",
        "step": "Step {step} of {total}",
        "contractStandard": "Contract standard",
        "execution": "Execution",
        "selfPerform": "Self-perform",
        "subcontract": "Subcontract",
        "format": "Format",
        "original": "Original format",
        "missingDocument": "Referenced document missing: {name}",
        "generateHint": "Review the file choices before preparing the work pack.",
        "previewOnly": "Preview only. Downloadable file generation is not connected yet.",
        "previewReady": "Version {version}: {count} file choices prepared.",
        "back": "Back",
        "continue": "Continue",
        "previewFiles": "Preview file choices",
        "checkpoints": "Checkpoints from Volve",
        "handled": "Mark as handled",
        "ignore": "Ignore",
        "noCheckpoints": "No checkpoints for this version.",
        "documentView": "Document view",
        "generateSteps": {
          "0": "Add other documents",
          "1": "Contract standard",
          "2": "Structure",
          "3": "Self-perform or subcontract",
          "4": "Format per file",
          "5": "Prepare the work pack"
        },
        "generateSection": "Preview generated section",
        "sectionPreviewOnly": "Content preview only. Section generation and PDF export are not connected yet.",
        "mergedPreview": "Preview merged work pack",
        "undoHandled": "Handled · undo",
        "clientChangeLog": "Change log against the client",
        "checkpointsPending": "The checkpoints will appear after this version finishes generating.",
        "moveUp": "Move section up",
        "removeFile": "Remove file",
        "downloadMerged": "Download merged PDF",
        "progress": {
          "dispatching": "Waiting to start…",
          "retrying": "Restarting file generation…",
          "writing": "Writing the selected files…",
          "sources": "Collecting source documents…",
          "files": "Saving generated files…",
          "page_bundle": "Preparing source pages and highlights…",
          "merging": "Combining the work-pack PDF…",
          "complete": "Files saved. Finishing…"
        },
        "filesReady": "{count} of {total} files saved",
        "safeToLeave": "You can leave this page. Generation continues, and you can return to see its progress.",
        "descriptionMethod": "Description method: {method}",
        "changeDescriptionMethod": "Choose description",
        "notChosen": "Not chosen",
        "invalidPageRange": "Choose whole pages within the document, with the first page no later than the last.",
        "generationFailed": "File generation did not finish. Try again.",
        "generateFilesHint": "Generate the selected files and a combined PDF for this work-pack version.",
        "snapshotVersion": "Files from version {version}",
        "fromPage": "From page",
        "throughPage": "Through page",
        "generatedDocument": "Generated document",
        "viewDocument": "View document"
      },
      "execution": {
        "lines": "items",
        "allLines": "All {lines}",
        "search": "Search code or description",
        "code": "Code",
        "description": "Description",
        "chapter": "Client chapter",
        "quantity": "Quantity",
        "state": "Source",
        "clientOriginal": "Client original",
        "added": "Added",
        "current": "Current work pack",
        "commonPart": "Common part · goes into every work pack",
        "noLines": "No matching items.",
        "changes": "Changes against the client",
        "changesHint": "These changes belong to the work pack. Internal edit history stays separate.",
        "noChanges": "No changes against the client.",
        "changeKinds": {
          "added": "Added",
          "edited": "Edited",
          "moved": "Moved",
          "removed": "Removed",
          "condition_added": "Added condition"
        },
        "nextPosts": "Next: review {lines}",
        "overviewIntro": "The client’s chapters and posts form your work packs. Choose how each pack will be executed."
      },
      "takeoff": {
        "title": "Drawing quantities",
        "instructions": "Scope to measure",
        "measure": "Make quantities to check",
        "pending": "Measuring…",
        "accept": "Use selected quantities",
        "accepted": "Selected quantities saved",
        "error": "Could not save quantities",
        "help": "Check the calculations and marked drawings before using these quantities in generated posts.",
        "empty": "No drawing quantities yet.",
        "fees": "Run cost: ${cost} + ${container} container",
        "selected": "Use this quantity",
        "unmeasured": "Not measured",
        "download": "Download {name}"
      },
      "fidelity": {
        "manual": "Manual",
        "completeStepFirst": "Complete “{step}” first.",
        "confirmRequirements": "Requirements look right",
        "sourceDocument": "Source document",
        "allSourceDocuments": "All source documents",
        "overview": "Overview",
        "package": "Package",
        "packages": "{count, plural, one {# package} other {# packages}}",
        "chapter": "Chapter",
        "chapters": "{count, plural, one {# chapter} other {# chapters}}",
        "requirements": "{count, plural, one {# requirement} other {# requirements}}",
        "version": "Version {version}",
        "draft": "Draft",
        "sent": "Sent",
        "notSent": "Not yet",
        "change": "Change",
        "next": "Next: {step}",
        "continue": "Continue",
        "approve": "Approve and send",
        "chooseDescription": "Choose description",
        "packagePosition": "Package {position} of {count}",
        "chapterPosition": "Chapter {position} of {count}",
        "overviewIntro": "Choose work packages, execution and description below. You can complete or change them later.",
        "emptyPackages": "{count, plural, one {# empty package} other {# empty packages}}",
        "showEmpty": "Show empty packages",
        "hideEmpty": "Hide empty packages",
        "newLine": "New {line}",
        "blankLine": "Blank {line}",
        "blankHint": "Fill in the fields yourself, in the standard’s layout.",
        "withVolve": "With Volve",
        "withVolveHint": "Describe what you need and optionally attach a file. Volve proposes drafts.",
        "missingQuantity": "Missing quantity",
        "noRigging": "No rigging items yet",
        "introduction": "Introductory text",
        "generated": "Generated by Volve",
        "regenerate": "Generate again",
        "internalHistory": "Internal only. Not sent to subcontractors.",
        "user": "User",
        "field": "Field",
        "unknownDocument": "Document unavailable",
        "packageLocation": "Work pack",
        "lineLocation": "{line} {number}",
        "suggested": "Volve suggests",
        "contractHint": "The standard for the contract with the subcontractor.",
        "standardsHint": "The selected standard is already included. Add other standards only if needed.",
        "inheritedStandard": "Already included: {name}",
        "chooseKnowledgeBase": "Choose from the knowledge base",
        "libraryFileCount": "{count, plural, one {# file} other {# files}}",
        "uploaded": "Uploaded",
        "addTenderFiles": "Add files from the tender",
        "startHint": "Choose what the breakdown starts from.",
        "startAction": "Start breakdown",
        "startDesignHint": "Volve reads the contract, finds every requirement and sorts them into work packages. You choose how each package is described afterwards.",
        "startExecutionHint": "Volve keeps the client’s chapters and wording and suggests one work pack per chapter.",
        "outline": "Contract outline",
        "outlineHint": "Only chapters with requirements in this package are shown.",
        "withoutHeading": "Without heading",
        "noSourceDocument": "No source document",
        "citationScope": "Citation scope",
        "contractScope": "Included in the contract",
        "source": "Source in the contract documents",
        "exact": "Exact",
        "paragraph": "Paragraph",
        "section": "Section",
        "chapterLevel": "Chapter",
        "document": "Document",
        "removeAll": "Remove all",
        "conditions": "Conditions",
        "includedCount": "{included} of {count}",
        "otherConditions": "Other conditions",
        "documents": "Documents in the work pack",
        "summary": "Summary",
        "uploadDocument": "Upload document",
        "generate": "Generate",
        "noDocument": "No document yet",
        "mergedPdf": "Generate merged PDF",
        "facts": "Package facts",
        "standard": "Standard",
        "sentLabel": "Sent",
        "responsible": "Responsible",
        "notAssigned": "Not assigned",
        "interfaces": "Interfaces",
        "moveDown": "Move section down",
        "checkpointsTab": "1. Checkpoints from Volve",
        "reviewTab": "2. Review entire pack",
        "checksLeft": "{count, plural, one {# checkpoint left} other {# checkpoints left}}",
        "checksIntro": "{count, plural, one {# checkpoint} other {# checkpoints}} before the pack is approved",
        "showInPack": "Show in pack",
        "downloadAll": "Download all",
        "executionIntro": "One work pack per chapter is suggested. You can combine now or later.",
        "executionTitle": "Description and bill of quantities",
        "generateHint": "Check who does each work pack before the files are made.",
        "generateExecution": "Confirm self-perform / subcontract",
        "generateFormats": "Choose file format per file",
        "generatePackage": "Generate work pack",
        "executionHelp": "Taken from the overview. Choose another work pack in the heading to check it. Self-performed packs become internal work packs; subcontracted packs go on to procurement.",
        "newLineTitle": "New {line} with Volve",
        "lineInstructions": "What should the {lines} cover?",
        "lineInstructionsHelp": "Required. Volve does not create {lines} without a description from you.",
        "optionalFile": "File (optional)",
        "alsoUses": "Volve also uses",
        "previewDrafts": "You see the suggestions before anything is added.",
        "close": "Close",
        "cancel": "Cancel",
        "newRun": "New breakdown",
        "company": "Company",
        "email": "Email",
        "deadline": "Offer deadline",
        "add": "Add",
        "noRecipients": "No recipients added. This preview does not send invitations.",
        "noOffers": "No offers received.",
        "total": "Total",
        "coverage": "Coverage",
        "risk": "Top risk",
        "showMore": "Show more",
        "showLess": "Show less",
        "commonParts": "Common parts",
        "unallocated": "Unallocated scope",
        "removed": "Removed",
        "uncoveredLines": "Requirements without a {line}: {count}",
        "removedLines": "Removed {lines}",
        "selectSource": "Select a requirement to view its source.",
        "selectConditionSource": "Select a condition to view its source.",
        "requirementsLabel": "Requirements",
        "sourceDocuments": "{count, plural, one {# document} other {# documents}}",
        "packageStatus": {
          "draft": "Draft",
          "ready": "Ready",
          "sent": "Sent",
          "offers_in": "Offers received",
          "awarded": "Awarded",
          "contracted": "Contracted"
        },
        "itemCount": "{count} {items}",
        "executionMeta": "{chapters} chapters · {posts} {items} · read by Volve from {files} files",
        "unpaginated": "Unpaginated",
        "configureStart": "Extract requirements",
        "configureStartHint": "Choose how to group the requirements into work packages.",
        "back": "Back",
        "noSummary": "No summary for this version.",
        "codeFromChoices": "The standard sets the code from the choices below.",
        "codeChanges": "The code changes",
        "codeChoiceUnavailable": "No code mapping is available for these choices in this version. The existing code is retained.",
        "move": "Move",
        "sourcePage": "p. {page}",
        "sourcePageRange": "pp. {from}–{to}",
        "noCommonParts": "No common parts available.",
        "whatInPack": "What goes into the work pack?",
        "noTenderBill": "No bill of quantities found in the documents.",
        "foundInStandard": "Found in the standard",
        "descriptionMethods": "Description methods",
        "performanceShort": "Functional and performance requirements. The supplier designs the solution. No posts.",
        "itemisedShort": "Priceable posts with code, fields and quantities.",
        "chooseMethodLater": "Choose a method for each package after reviewing the requirements.",
        "standardSummary": "{count, plural, one {# chapter} other {# chapters}} in selected parts · Export: {formats}",
        "includeInPack": "Include in the work pack",
        "standardOption": "Standard {number}",
        "correctStandard": "Correct",
        "commonPartStatus": "Common part",
        "noHistory": "No changes yet.",
        "postUpdated": "Post updated",
        "addStandard": "Add a standard from the library…",
        "noStandardMatch": "No standard matches",
        "optional": "(optional)",
        "completeStepFirstHint": "This step builds on the one before it. Finish that step, then come back here.",
        "addRecipients": "Add recipients"
      },
      "design": {
        "steps": {
          "label": "Steps",
          "requirements": "Requirements",
          "choose-description": "Choose description",
          "work-pack": "Work pack",
          "add-information": "Add information",
          "documents": "Work pack documents",
          "documentsItemised": "Work pack documents",
          "generate": "Generate work pack",
          "proofread": "Proofread and edit",
          "send": "Send",
          "offers": "Offers",
          "changes": "Changes against the client",
          "procurement": "Procurement"
        },
        "next": {
          "performance": {
            "requirements": "Choose description",
            "work-pack": "Continue",
            "documents": "Next: Generate work pack",
            "generate": "Continue",
            "proofread": "Approve and send",
            "send": "Send"
          },
          "itemised": {
            "requirements": "Choose description",
            "work-pack": "Next: Framework conditions",
            "add-information": "Continue",
            "documents": "Continue",
            "generate": "Continue",
            "proofread": "Approve and send",
            "send": "Send"
          },
          "execution": {
            "overview": "View and edit posts per chapter",
            "client-posts": "Next: information and documents",
            "changes": "Next: information and documents",
            "add-information": "Next: work pack",
            "documents": "Next: Generate work pack",
            "proofread": "Approve and go to procurement",
            "send": "Send"
          }
        },
        "crumbs": {
          "add-information": "Information and documents",
          "documents": "Work pack documents",
          "generate": "Work pack",
          "proofread": "Proofread",
          "send": "Procurement",
          "offers": "Offers",
          "work-pack": "Work pack",
          "requirements": "Requirements",
          "choose-description": "Choose description"
        },
        "moreActions": "More options",
        "backToOverview": "Back to overview",
        "clientChanges": "Changes against the client",
        "quantities": "Quantities",
        "regenerate": "Generate new version",
        "workPacks": "{count, plural, one {# work pack} other {# work packs}}",
        "chapters": "{count, plural, one {# chapter} other {# chapters}}",
        "executionTitle": "{project} – Description and bill of quantities",
        "proofreadCrumb": "Proofread and edit · work pack version {version} · {standard}",
        "chaptersCrumb": "Chapters",
        "workPackPosition": "Work pack {position} of {count}",
        "chapterPosition": "Chapter {position} of {count}",
        "addInformationHint": "Add additional information and framework conditions",
        "nothingLeft": "Nothing left to check",
        "exportUnavailable": "Downloading generated files is not connected yet.",
        "packagesCrumb": "Packages",
        "itemisedCrumb": "Packages described by {line}",
        "details": "{count, plural, one {# detail} other {# details}}",
        "previewPack": "View preliminary pack",
        "searchPackage": "Search the package requirements",
        "generateTitle": "{count, plural, one {Make description} other {Make descriptions for # packages}}",
        "generateAction": "{count, plural, one {Make description} other {Make descriptions (#)}}",
        "missingMethod": "Choose a description method first for: {names}",
        "frameworkConditions": "Framework conditions",
        "clarify": "To clarify",
        "move": "Move",
        "delete": "Delete",
        "clearSelection": "Clear selection",
        "requirementCount": "{count} req.",
        "citationNotes": {
          "manual": "The citation shows the text you marked yourself.",
          "exact": "The citation shows only the marked sentence.",
          "paragraph": "The citation shows the whole paragraph around the requirement.",
          "section": "The citation shows the whole section around the requirement.",
          "chapter": "The citation shows the whole chapter.",
          "document": "The citation shows the whole document."
        },
        "contractNotes": {
          "manual": "The text you marked yourself goes into the work pack.",
          "exact": "Only the marked sentence goes into the work pack.",
          "paragraph": "The whole paragraph goes into the work pack.",
          "section": "The whole section goes into the work pack.",
          "chapter": "The whole chapter goes into the work pack.",
          "document": "The whole document goes into the work pack."
        },
        "allChecksDone": "All checkpoints are done",
        "ignored": "Ignored",
        "done": "Done",
        "reviewMeta": "{project} · Work pack {name} · version {version}",
        "freeText": "free text",
        "today": "Today {time}",
        "yesterday": "Yesterday {time}",
        "clientPost": "Client post {number}.",
        "requirementsCovered": "Requirements the post covers",
        "linkRequirement": "Link requirement",
        "unlinkRequirement": "Remove requirement from the post",
        "fieldsHint": "Fields with an arrow have fixed choices from the standard. Fields without fixed choices are free text.",
        "quantityWithUnit": "Quantity ({unit})",
        "clientOriginal": "Client's original text",
        "clientChangeTracked": "Your change is tracked in the change log, since the client's text is the contract.",
        "history": "History",
        "changed": "changed {changes}",
        "savePost": "Save post",
        "editRiggingLine": "Edit rigging post",
        "quantityPlaceholder": "Missing quantity",
        "quantityMissingHint": "The quantity is not in the tender documents. Enter it before you send.",
        "enterQuantity": "Enter quantity",
        "enterQuantityShort": "Enter",
        "assumedHint": "Assumed by Volve. Confirm or change it in the post.",
        "chapterLabel": "Chapter",
        "riggingPosts": "Rigging posts",
        "riggingSelected": "{selected} of {count} selected",
        "riggingFrom": "From {chapter}",
        "riggingIncluded": "{count} {lines} included in this work pack",
        "editShort": "Edit",
        "riggingCount": "{count, plural, one {# rigging post} other {# rigging posts}}",
        "riggingHint": "No rigging posts have been added to this package.",
        "chooseRigging": "Choose rigging posts",
        "blankLine": "Blank {line}",
        "actions": "Actions",
        "showLine": "Show {line} details",
        "editLine": "Edit {line}",
        "addedMark": "Added",
        "addLine": "Add {line}",
        "addedHint": "New {lines} are marked «Added».",
        "uncoveredLabel": "Requirements without a {line}:",
        "uncoveredNone": "Every requirement in the package has a {line}.",
        "uncoveredSome": "These requirements are not covered by a {line} yet.",
        "newLineExecutionHint": "{name} · added posts are marked «Added» against the client",
        "fileLabel": "File",
        "optional": "(optional)",
        "pages": "{count, plural, one {# page} other {# pages}}",
        "removeFile": "Remove file",
        "fileHint": "PDF, Excel, Word or image. An offer, a quantity list or your own notes.",
        "linesInChapter": "{count} {lines} in {name}",
        "alsoUsesHint": "Volve searches what it needs.",
        "alsoUsesExecutionHint": "Volve searches what it needs. New posts are listed in the change log against the client.",
        "makeSuggestions": "Make suggestions",
        "method": "Description method",
        "subcontractFor": "Use {name} if the main contract is {main}.",
        "chooseContractStandard": "Choose contract standard",
        "suggestsStandard": "Volve suggests {name}.",
        "addReferenceFile": "Add a source file or standard",
        "uploadStandards": "Upload additional standards",
        "missingStandards": "{count, plural, one {Suggests # more standard} other {Suggests # more standards}}",
        "upload": "Upload",
        "alwaysIncluded": "Whichever you choose, the requirements with page references and the framework conditions go with the package.",
        "continue": "Continue",
        "makeDescription": "Make description",
        "backToRequirements": "Back to requirements",
        "selectedPackages": "Selected packages",
        "chooseMethod": "Choose description method",
        "methodsFromStandard": "The choices come from the standard you chose. Applies to the {count} selected packages.",
        "combine": "Combine",
        "combineUnavailable": "Combining chapters is not available yet.",
        "makeDescriptions": "Make description ({count})",
        "makeDescriptionsHint": "Makes descriptions for the selected packages in the background. Packages without a description method ask first.",
        "addChapter": "Add chapter",
        "combineTitle": "Combine {count} packages",
        "combineBody": "The requirements in {others} move to {target}. Packages left empty are hidden.",
        "chaptersTitle": "Chapters",
        "workPackChoice": "Work pack · choose now or later",
        "packagesWord": "{count, plural, one {package} other {packages}}",
        "suggestionsWord": "{count, plural, one {suggestion} other {suggestions}}",
        "conflictsWord": "{count, plural, one {conflict} other {conflicts}}",
        "mergeTitle": "Usually bought together",
        "mergeNote": "Nothing is combined unless you choose it. The chapter in the standard still controls the codes.",
        "conflictCount": "{count, plural, one {# conflict} other {# conflicts}}",
        "outsideRequirements": "{count, plural, one {# requirement} other {# requirements}} outside the standard",
        "outsidePackages": "in {count, plural, one {# package} other {# packages}}: {names}",
        "milestones": {
          "requirements": "Requirements checked",
          "method": "Method chosen",
          "described": "Described",
          "sent": "Sent"
        },
        "previewCount": "Requirements in the package · showing {shown} of {count}",
        "conditionsFound": "Volve found {count, plural, one {# framework condition} other {# framework conditions}} in the tender documents that apply to the package. {included} are included.",
        "noConditionsFound": "Volve found no framework conditions in the tender documents that apply to the package.",
        "includeAll": "Include all",
        "includeInPack": "Include in the package",
        "openPdf": "Open PDF",
        "scopeShort": {
          "manual": "Manual",
          "exact": "Exact",
          "paragraph": "Paragraph",
          "section": "Part chapter",
          "chapter": "Whole chapter",
          "document": "Whole document"
        },
        "chooseScope": "Choose scope",
        "chooseOne": "Choose one.",
        "scopeOptions": {
          "manual": "Use the text marked by hand",
          "exact": "Only the marked text",
          "paragraph": "Expand to paragraph",
          "section": "Expand to part chapter",
          "chapter": "Expand to chapter",
          "document": "Include whole document"
        },
        "scopeOptionHints": {
          "manual": "The text marked by hand goes in.",
          "exact": "Only the marked text goes in.",
          "paragraph": "The whole paragraph around the text goes in.",
          "section": "{number} only. The cited section goes in.",
          "chapter": "The whole chapter {number} belongs to.",
          "document": "The full {document} as an appendix."
        },
        "remove": "Remove",
        "paragraphs": "{count, plural, one {# paragraph} other {# paragraphs}}",
        "riggingGroup": "{chapter} · {count} {lines} already included in Posts are not shown",
        "include": "Include",
        "otherLines": "Other {lines}",
        "uploadQuantities": "Upload list and quantities",
        "uploadQuantitiesHint": "Choose a file from the tender. Volve suggests which {lines} the quantities belong to.",
        "citation": "Citation",
        "marked": "Marked:",
        "postsLabel": "Posts",
        "contractStandard": "Contract standard",
        "basis": "Source",
        "basisPages": "{pages, plural, one {# page} other {# pages}} from {documents, plural, one {# document} other {# documents}}",
        "sendTitle": "Send {name}",
        "companyPlaceholder": "Company name",
        "emailPlaceholder": "name@company.com",
        "deadlineShort": "due {date}",
        "sendVersion": "Send version {version}",
        "startSubtitle": "{project} · choose what the breakdown starts from.",
        "clientDescription": "Client's description",
        "clientRequirements": "Client's requirements",
        "foundContractStructure": "Found contract standard <b>{standard}</b>, {chapters} chapters and {lines} {term}.",
        "foundContractOnly": "Found contract standard <b>{standard}</b>."
      },
      "review": {
        "manualHint": "Mark the text in the document on the right, then use the selection.",
        "manualEmpty": "Mark some text in the document first.",
        "useSelection": "Use selection",
        "cancelMarking": "Cancel",
        "markNewText": "Mark new text",
        "startsNow": "Starts right away. You see the progress in the next step.",
        "describingTitle": "While the description is being made",
        "describingLocked": "The choices are locked until the description is done.",
        "seeProgress": "See progress",
        "standardProcessing": "Reading…",
        "standardFailed": "Could not be read",
        "standardReady": "Ready",
        "standardProcessingHint": "Volve waits to use a standard until it has been read. You can carry on meanwhile.",
        "describeFailed": "The description did not finish",
        "retry": "Try again",
        "describingHeading": "Volve is making the description",
        "queued": "Queued",
        "queuedAt": "Queued · no. {position}",
        "queuedHint": "Starts when the packages ahead in the queue are done.",
        "percent": "{value}%",
        "progressLabel": "Progress",
        "describingHint": "You can go to other packages meanwhile. This step updates by itself.",
        "stages": {
          "reading": "Reading the requirements",
          "summary": "Summary",
          "interfaces": "Interfaces",
          "conditions": "Framework conditions",
          "lines": "Items",
          "quantities": "Quantities",
          "finishing": "Finishing"
        },
        "errors": {
          "source_not_ready": "A source ({document}) has not been read yet. Try again shortly, or upload it yourself.",
          "source_missing": "A source ({document}) is no longer in the workspace.",
          "level_not_read": "A requirement points to a source level Volve has not read. Pick another level on the requirement.",
          "execution_missing": "Choose self-perform or subcontract first.",
          "description_busy": "The description is being made. Try again when it is done.",
          "build_busy": "Something else in the package is being made. Try again when it is done.",
          "worker_failed": "Something went wrong at Volve. Try again."
        },
        "draftTitle": "Draft package",
        "draftBadge": "Draft",
        "draftMeta": "{title} · description + {count, plural, one {# requirement} other {# requirements}} · draft, not sent",
        "draftDownloadFailed": "Could not download the draft.",
        "draftFileName": "Draft {title}",
        "draftFailed": "Could not show the draft. Try again.",
        "draftStamp": "DRAFT",
        "draftIntroduction": "Introduction",
        "draftInterfaces": "Interfaces with other packages",
        "draftConditions": "Framework conditions",
        "draftPage": "p. {page}",
        "attachedHint": "{name} is attached to the package",
        "merge": "Merge into one PDF",
        "mergeWaiting": "Waiting for {count, plural, one {# document} other {# documents}}",
        "mergeFailed": "The merge did not finish: {reason}",
        "workPackRow": "The work package",
        "workPackFile": "Technical description {name}",
        "workPackMeta": "Description + {count, plural, one {# requirement} other {# requirements}}",
        "generated": "Generated",
        "previewAction": "Preview",
        "download": "Download draft (PDF)",
        "slotWriting": "Volve is writing the document…",
        "slotLocked": "You can work on the other documents meanwhile",
        "slotFailed": "Could not generate: {reason}",
        "removedRequirements": "{count, plural, one {# requirement} other {# requirements}} removed from the package",
        "removeFromPackage": "Remove from package",
        "citationScopeSummary": "Source: <strong>{level}</strong>",
        "contractScopeSummary": "In the contract: <strong>{level}</strong>",
        "contractScopeHint": "Volve sets these for each requirement. Source decides how much text is shown; in the contract decides what goes into the work pack.",
        "hide": "Hide",
        "change": "Change",
        "outsideHint": "These requirements did not fit any item in the standard. Volve collected them in their own packages. Open a package to move requirements where they belong.",
        "requirementCount": "{count, plural, one {# requirement} other {# requirements}}",
        "open": "Open",
        "needsInput": "Needs input",
        "enter": "Enter",
        "quantity": "Quantity",
        "questionTitle": "Volve needs an answer before this item can be quantified",
        "updateLine": "Update item",
        "inputSummary": "{fields, plural, one {# field} other {# fields}} need input, across {lines, plural, one {# item} other {# items}}",
        "legendKnown": "From the documents",
        "legendAssumption": "Volve's assumption",
        "legendInput": "Needs input",
        "answerFirst": "Answer first",
        "movedOut": "{count, plural, one {# requirement} other {# requirements}} moved to “{name}”. {lines, plural, =0 {No items were removed.} one {# item that only covered them was removed here.} other {# items that only covered them were removed here.}}",
        "dismiss": "Close",
        "movedIn": "{count, plural, one {# requirement} other {# requirements}} moved here. Volve is writing and quantifying new items for them.",
        "showFullText": "Show full text",
        "volveSuggestion": "Volve's suggestion",
        "rolesTitle": "Roles in the text",
        "rolesHint": "The requirements are written from the client (BH) to the main contractor (TE). How should the subcontractor read them?",
        "rolesRewrite": "Rewrite the requirements.",
        "rolesRewriteHint": "TE becomes UE and BH becomes TE in all requirement text. The original is one click away.",
        "rolesIntro": "Keep the original text.",
        "rolesIntroHint": "The introduction gets the sentence: “Where it says TE, UE is responsible for delivery. Where it says BH, TE is meant.”",
        "showOriginal": "Show original",
        "showRewritten": "Show rewritten",
        "removedList": "Removed from the package ({count})",
        "restore": "Restore",
        "mergeNothing": "Every document is marked not relevant"
      }
    },
    "sheets": {
      "empty": "This sheet has no tabs yet",
      "editorUnavailable": "Live editing is unavailable. Showing the last saved version.",
      "review": "Review",
      "inputErrors": {
        "number": "Enter a number",
        "option": "Choose one of the column options",
        "reference": "References come from the agent and cannot be typed"
      },
      "unknownDocument": "Document",
      "page": "Page {page}",
      "columnTypes": {
        "text": "Text",
        "number": "Number",
        "enum": "Choice",
        "date": "Date",
        "reference": "Reference"
      },
      "save": "Save",
      "rowNumber": "Row {number}",
      "undo": "Undo",
      "redo": "Redo",
      "download": "Download (.xlsx)",
      "downloadError": "Could not download the sheet. Try again.",
      "tabFallback": "Tab {number}",
      "openRow": "Open row details and comments",
      "editRefused": "The change was not made",
      "unsavedRow": "Not saved",
      "unsavedRowDescription": "Save new rows before you review them or create tasks for them",
      "saveRows": "Save {count, plural, one {new row} other {# new rows}}",
      "saveError": "Could not save the sheet. Try again.",
      "sources": "Sources",
      "sheetInScopeBreakdown": "This sheet is the scope breakdown",
      "sheetInScopeBreakdownDescription": "View and edit it in the workspace's scope breakdown.",
      "openScopeBreakdown": "Open scope breakdown"
    },
    "packageSharing": {
      "recipients": "Recipients",
      "offers": "Offers",
      "addRecipient": "Add recipient",
      "updateRecipients": "Update recipients",
      "noRecipients": "No recipients yet.",
      "anyRecipient": "Link recipient",
      "version": "Version {version}",
      "deadline": "Offer deadline {date}",
      "activity": "{visits} visits · {downloads} downloads · {questions} questions · {offers} offers",
      "revoke": "Revoke link",
      "revoked": "Revoked",
      "sendTitle": "Send {name}",
      "sendExplanation": "Version {version} is frozen when shared. Each recipient gets a separate link and does not need to log in. Volve does not send invitations.",
      "company": "Company (optional)",
      "email": "Email",
      "offerDeadline": "Offer deadline",
      "expiry": "Link expiry (optional)",
      "expiryHint": "Defaults to 30 days after the offer deadline.",
      "add": "Add",
      "remove": "Remove",
      "download": "Download",
      "chat": "Ask about the package",
      "upload_offer": "Upload offer",
      "shareLink": "Share link",
      "copy": "Copy",
      "copied": "Copied",
      "emailDraft": "Draft email",
      "draftBody": "Please review {name} and submit your offer using this link: {url}",
      "shownOnce": "Copy this link now. It will not be shown again after leaving this page.",
      "generateFirst": "Generate the work pack before sending it.",
      "close": "Close",
      "sendVersion": "Send version {version}",
      "limitError": "The usage limit has been reached. Please try again later or contact the sender.",
      "verifyError": "Please verify your email before continuing.",
      "linkError": "This link is unavailable, expired or revoked. Please contact the sender.",
      "error": "This action could not be completed. Please try again or contact the sender.",
      "unavailable": "Package unavailable",
      "requestForOffer": "Request for offer",
      "overview": "Overview",
      "conditions": "Framework conditions",
      "items": "Items",
      "drawings": "Drawings",
      "documents": "Documents",
      "about": "About the package",
      "allConditions": "See all {count} conditions",
      "contents": "Contents",
      "counts": "{items} {itemLabel} and {pages} source pages",
      "contact": "Contact",
      "contract": "Contract",
      "madeWith": "Prepared with Volve.",
      "tryVolve": "Try it on your own tenders",
      "uploadOffer": "Upload offer",
      "view": "View",
      "ask": "Ask about the package",
      "chatBoundary": "Answers use only the documents in this package.",
      "question": "Ask a question",
      "answering": "Answering…",
      "send": "Send",
      "verifyTitle": "Verify your email",
      "verifyHelp": "A one-time code is required before your first question or upload. No account is created.",
      "sendCode": "Send code",
      "code": "One-time code",
      "verify": "Verify",
      "offerReceived": "Your offer has been received.",
      "scanning": "The offer is private while its malware scan completes.",
      "checkScan": "Check scan status",
      "updated": "The sender has updated this package. Changed:",
      "changed": {
        "summary": "Summary",
        "introduction": "Introduction",
        "interfaces": "Interfaces",
        "items": "Items and requirements",
        "conditions": "Conditions",
        "sections": "Document sections",
        "delivery_matrix": "Delivery matrix",
        "files": "Files"
      },
      "deliveryMatrix": "Delivery matrix",
      "interfaces": "Interfaces",
      "settings": "Sharing settings",
      "enabled": "Allow external sharing",
      "requireEmail": "Require recipient email",
      "allowChat": "Allow package chat",
      "maxExpiry": "Maximum link lifetime (days)",
      "dailyQuestions": "Questions per link per day",
      "dailyCost": "Cost limit per link per day (USD)",
      "save": "Save",
      "contactConsent": "I consent to Volve keeping my contact details for follow-up.",
      "resendCode": "Request a new code",
      "linkActivity": "Link activity",
      "clarifyQuestion": "Create clarification",
      "clarificationCreated": "Clarification created",
      "activityRecorded": "Activity recorded",
      "guestRetention": "Keep guest data after expiry (days)",
      "firstOpened": "First opened {date}",
      "lastOpened": "Last opened {date}",
      "botUnavailable": "Verification is unavailable. Please try again.",
      "openOffer": "Open offer files",
      "expiryRequired": "Choose an expiry no later than {date}.",
      "copyFailed": "Could not copy. Select and copy the link manually.",
      "chatGreeting": "Questions about this package?",
      "chatStarters": [
        "What does this package include?",
        "Which deadlines and penalties apply?",
        "What must the offer contain?"
      ]
    }
  },
  "pages": {
    "subcontractorBids": {
      "settings": {
        "disciplines": "Requirements"
      },
      "createProcurement": {
        "description": "Define a procurement pack from its requirements to collect and compare subcontractor offers.",
        "steps": {
          "disciplines": "Requirements"
        }
      }
    }
  },
  "components": {
    "workPackages": {
      "tender": {
        "wizard": {
          "description": "Select requirements to move into this package, or leave it empty.",
          "scopeCount": "{count, plural, =1 {# requirement} other {# requirements}}",
          "createdToast": "Work package created",
          "name": "Package name",
          "loadFailed": "Could not load requirements",
          "retry": "Try again",
          "empty": "No requirements available yet",
          "rest": "Rest scope",
          "requirements": "Requirements"
        }
      }
    }
  }
}
